import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { RectangleInput } from 'swag-client-common/components/inputs/rectangle-input';
import classes from './build-a-cart-create-link-popup.scss';
export const BuildACartCreateLinkPopup = ({
  open,
  email,
  cartLink,
  onContinue,
  onDone,
  onCopy
}) => {
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    open: open,
    title: `Your Cart Link for ${email}`,
    cancelText: "Continue Editing",
    confirmText: "Done",
    onCancel: onContinue,
    onClose: onContinue,
    onConfirm: onDone,
    msg: /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement(RectangleInput, {
      formType: "text",
      className: classes.input,
      input: {
        value: cartLink
      },
      disabled: true
    }), /*#__PURE__*/React.createElement(CopyToClipboard, {
      text: cartLink,
      onCopy: onCopy
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.inputActionButton
    }, "Copy")))
  });
};